import { useState, memo } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import classes from "./EditOrderModal.module.scss";
import { OrderHistoryItem } from "../../products";
import { updateOrderStatusToFireStore } from "../../../functions/orders";
import { useSelector } from "react-redux";
import { getUserInfo } from "../../../reducks/users/selectors";

const style = {
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%", // 0px以上の幅で360pxを適用
      sm: "80%", // 600px以上の幅で400pxを適用
    },
    bgcolor: "background.paper",
    border: "none",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "20px 0",
  },
};

// 発注処理一覧の編集アイコンから開く注文詳細ダイアログ。
// ステータス遷移の可否判定は配下の OrderedProducts が
// functions/order/statusTransition.js を使って行う
// (以前はこのファイルにも呼び出しゼロの重複定義が残っていた)。
export const EditOrderModal = memo((props) => {
  const { orderId, orderUid, setIsShow, targetOrderList } = props;
  const [open, setOpen] = useState(true);
  const userInfo = useSelector(getUserInfo);

  const handleClose = () => {
    setIsShow(false);
    setOpen(false);
  };

  // ステータスの更新が実行されたとき
  const updateOrderStatus = async (status, order, dateInput) => {
    try {
      await updateOrderStatusToFireStore(status, order, userInfo, dateInput);
    } catch (error) {
      alert(
        "ステータスの更新に失敗しました。通信環境を確認して再度お試しください。"
      );
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style.box}>
          <div className={classes.root}>
            {targetOrderList.map((order) => (
              <OrderHistoryItem
                order={order}
                key={order.order_id}
                updateOrderStatus={updateOrderStatus}
                orderUid={orderUid}
              />
            ))}
          </div>
        </Box>
      </Modal>
    </div>
  );
});
